import { useMutation } from '@tanstack/react-query';
import { ViewerApi } from 'Data/Viewer.api';
import { ViewerEngineEnum } from 'Data/enums/ViewerEngine';

interface IRenderViewerFileRequest {
  constructionSiteId: number;
  fileApiId: string;
  /** Ausente = Autodesk. */
  engine?: ViewerEngineEnum;
}

// Render com a resposta em mãos. Não passa pela saga do Autodesk de propósito:
// o nativo não consome a cota de conversões da Autodesk que a saga contabiliza,
// e quem chama precisa da resposta para decidir o próximo passo.
export const useQueryRenderViewerFile = () => {
  return useMutation({
    mutationFn: async ({ constructionSiteId, fileApiId, engine }: IRenderViewerFileRequest) => {
      const { data } = await ViewerApi.renderViewerFile({
        constructionSiteId,
        fileApiId,
        folderId: '',
        engine,
      });
      return data.data;
    },
  });
};
